angular.module('wbDirectives').directive 'input', ->
  restrict: 'E'
  require: '?ngModel'
  link: ($scope, elem, attrs, ctrl) ->
    if (ctrl and attrs.type is 'range')
      ctrl.$parsers.push parseFloat
